import { render, staticRenderFns } from "./PCBrackets.vue?vue&type=template&id=676c3a36&scoped=true"
import script from "./PCBrackets.vue?vue&type=script&lang=js"
export * from "./PCBrackets.vue?vue&type=script&lang=js"
import style0 from "./PCBrackets.vue?vue&type=style&index=0&id=676c3a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c3a36",
  null
  
)

export default component.exports